import toast from './toasts'

async function handleService(serviceFn, input) {
  let promise = await serviceFn(input)
  if (promise.errors) {
    throw promise.errors
  }
  return promise
}

/**
 * @param {string} name - the name of the method
 * @param {Array<function>} service - the service function to invoke and the success notification to show
 * @param {function} [mapInput] - maps the form data to the service input
 * @param {function} [onSuccess] - the success callback
 * @param {function} [onError] - the error callback
 */
export default function createMutationMixin ({ name, service, mapInput, onSuccess, onError }) {
  return {
    methods: {
      [name] (input, resolve, actions) {
        handleService.call(
          this,
          service[0],
          mapInput ? mapInput.call(this, input) : input,
        )
          .then((response) => {
            let successMessage = service.length > 1 ? service[1] : null
            successMessage && toast.showSuccessToast(this.$t(successMessage))
            onSuccess && onSuccess.call(this, response, input)
          })
          .catch((errors) => {
            if(onError){
              onError.call(this, errors, actions)
            } else {
              toast.showErrorToast(this.$t('errors.' + errors[0].extensions.errorKey))
            }
          })
          .finally(resolve)
      }
    }
  }
}
